<template>
  <div class="fu-drp" data-test="fu-drawer-progress">
    <div v-if="segments.length" class="fu-drp__segs" aria-hidden="true">
      <span
        v-for="s in segments"
        :key="s"
        class="fu-drp__seg"
        :class="{ 'fu-drp__seg--on': s <= done }"
      ></span>
    </div>
    <span class="fu-drp__text" data-test="fu-drawer-progress-text">
      <strong>{{ done }}</strong>{{ suffix }}
    </span>
  </div>
</template>

<script>
/**
 * DrawerAttemptProgress — "X of Y attempts" from the office's maximum (drawerQueues.maxFollowupsOf
 * → alertConditions().maxFollowups), with the design's segment bar. No maximum (claims — bug 2 is
 * KEPT — or an office that set none) → "X attempts", no segments; today's counter shows only
 * "X completed" then. A maximum above 12 keeps the text but drops the bar (it would not fit).
 * Presentational.
 */
const MAX_SEGMENTS = 12;

export default {
  name: 'DrawerAttemptProgress',
  props: {
    attempts: { type: [Number, String], default: 0 },
    max: { type: [Number, String], default: null },
  },
  computed: {
    maxN() {
      const m = parseInt(this.max, 10);
      return Number.isFinite(m) && m > 0 ? m : null;
    },
    total() {
      return Number(this.attempts) || 0;
    },
    done() {
      return this.maxN ? Math.min(this.total, this.maxN) : this.total;
    },
    segments() {
      if (!this.maxN || this.maxN > MAX_SEGMENTS) return [];
      return Array.from({ length: this.maxN }, (_, i) => i + 1);
    },
    suffix() {
      if (this.maxN) return ` of ${this.maxN} attempts`;
      return this.total === 1 ? ' attempt' : ' attempts';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drp {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.fu-drp__segs { display: flex; gap: 3px; }

.fu-drp__seg {
  width: 12px;
  height: 6px;
  border-radius: 3px;
  background: $fu-neutral-200;
}

.fu-drp__seg--on { background: $fu-brand; }

.fu-drp__text {
  font-size: 12.5px;
  color: $fu-text-muted;
  white-space: nowrap;
  strong { color: $fu-text; font-weight: $fu-fw-bold; }
}
</style>
